import React from 'react';
import { CheckIcon } from 'lucide-react';
import { offerChecklist, BOX_IMAGE, CHECKOUT_URL } from '../data/content';
import { CTAButton, TrustLine } from './CTAButton';
export function Offer() {
  return <section id="comprar" className="scroll-mt-1 bg-white px-3 py-4 sm:px-6" data-id="element-115" data-mp="1mnscei9wcob6">
      <div className="mx-auto max-w-lg" data-id="element-116" data-mp="1hopi9svgg2hz">
        <p className="text-center font-heading text-[0.66rem] font-extrabold uppercase tracking-[0.22em] text-gold sm:text-xs" data-id="element-117" data-mp="1hpqrdrswuex2">
          Special Launch Offer
        </p>
        <div className="mt-1 rounded-lg border-2 border-gold bg-ice p-3 shadow-lg" data-id="element-118" data-mp="p0a75hfg24bx">
          <h2 className="text-center font-heading text-[1.15rem] font-extrabold uppercase leading-tight text-navy sm:text-[1.6rem]" data-id="element-119" data-mp="13wrg6205v6vb">
            🧹 Cleaning Ready™
          </h2>
          <p className="text-center font-heading text-[0.66rem] font-bold uppercase tracking-wide text-brightblue sm:text-xs" data-id="element-120" data-mp="z0aowyxo0ce0">
            The Complete Ready-to-Use Operating System for Cleaning
            Professionals
          </p>

          <a href={CHECKOUT_URL} rel="noopener" className="mt-1.5 block" data-id="element-121" data-mp="pl0ew0ib06h1">
            <img src={BOX_IMAGE} alt="CLEANING READY™ complete 6-in-1 system" className="mx-auto w-full max-w-[165px]" data-id="element-122" data-mp="ujbr2hw2mt2f" />
          </a>

          <p className="mt-0.5 text-center font-heading text-[0.74rem] font-extrabold uppercase tracking-wide text-navy" data-id="element-123" data-mp="zgk4y6a6saxv">
            Complete 6-in-1 System
          </p>

          <ul className="mt-1.5 space-y-0.5" data-id="element-124" data-mp="6vkc16j5c1xg">
            {offerChecklist.map(item => <li key={item} className="flex items-start gap-1.5" data-id="element-125" data-mp="btc17ssep9xy">
                <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-confirm" strokeWidth={3.5} aria-hidden="true" data-id="element-126" data-mp="fu5pin9rgqrd" />
                <span className="text-[0.8rem] leading-[1.35] text-navy sm:text-[0.95rem]" data-id="element-127" data-mp="3k95lmipuz5ka">
                  {item}
                </span>
              </li>)}
          </ul>

          <p className="mt-2 text-center font-heading text-[0.84rem] font-extrabold uppercase leading-tight text-navy sm:text-base" data-id="element-128" data-mp="vfh4q7ui0tjc">
            🔥 Get Cleaning Ready™ today
          </p>
          <p className="text-center font-heading text-[2.4rem] font-extrabold leading-none text-gold sm:text-5xl" data-id="element-129" data-mp="155k7v0vc3nve">
            $26.90
          </p>

          <div className="mt-2" data-id="element-130" data-mp="107s4nap8ofbw">
            <CTAButton label="🧹 Get instant access" sub="Immediate Digital Access" target="checkout" data-id="element-131" data-mp="108jzgjb0i914" />
          </div>
          <TrustLine className="mt-1.5" data-id="element-132" data-mp="7jcryutky93q" />
        </div>
      </div>
    </section>;
}